<template>
     <el-card class="box-card" style="width: 1300px;margin:80px auto 0;">
     <el-table
      :data="tableData"
      >
      <el-table-column
        prop="title"
        label="主题"
        >
      </el-table-column>
      <el-table-column
        prop="creater"
        label="创建者">
      </el-table-column>
        <el-table-column
        prop="inserttime"
        label="创建日期"
        >
      </el-table-column>
       <el-table-column
        prop="cot"
        label="状态"
        >
         <template slot-scope="scope">
            <el-switch
            v-if="tableData[scope.$index].cot==0"
            inactive-color="#ff4949">
          </el-switch>
            <el-switch
            v-if="tableData[scope.$index].cot>0"
            inactive-color="#13ce66">
          </el-switch>
         </template>
      </el-table-column>
      <el-table-column
        label="操作"
      >
             <template slot-scope="scope">
                                 <el-button type="primary" @click.native="goPdf(scope.$index,tableData)">阅读</el-button>
             </template>
      </el-table-column>
    </el-table>
        
  </el-card>
</template>

   

<script>

export default {
    data() {
        return {
          tableData:[],
          }
    },
 
    methods:{
     
    init() {
     this.$http
        .post("Exam/GetSearchList", {
          action: "getExamPractice",
        })
        .then((res) => {
            // 
          if (res.data.isok) {
           
               this.tableData= res.data.data
          }
        })
        .catch((err) => {})

    },


    goPdf(index,tableData){
      this.$router.push({path:'/gopdf',query:{url:tableData[index].url,id:tableData[index].id}})
    }
 
   
    },

    created(){
        
         this.init()
    }
}
</script>

<style scoped>
  .VSTD_box_item_title{
    margin-top:10px;
  }
  .dt_ridio{
       border:1px solid #36d;
       display: inline-block;
       margin-right:5px;
       width:30px;
       height:30px;
       border-radius: 50%;
       text-align: center;
       line-height: 30px;
       font-size:15px;
       cursor: pointer;
  }
  .show_da{
    background-color:#36d;
    color:#fff;
  }
 
</style>


// WEBPACK FOOTER //
// src/components/Questions.vue